var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConstruction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0208 18.5831C32.8354 18.5831 35.125 16.2935 35.125 13.4789C35.125 12.6331 34.8917 11.8456 34.5271 11.1456L30.5896 15.0831L28.4167 12.9102L32.3542 8.97265C31.6542 8.60807 30.8667 8.37474 30.0208 8.37474C27.2062 8.37474 24.9167 10.6643 24.9167 13.4789C24.9167 14.0768 25.0333 14.6456 25.2229 15.1706L22.525 17.8685L19.9292 15.2727L20.9646 14.2372L18.9083 12.181L22 9.08932C20.2937 7.38307 17.5229 7.38307 15.8167 9.08932L10.6542 14.2518L12.7104 16.3081H8.59792L7.5625 17.3435L12.725 22.506L13.7604 21.4706V17.3435L15.8167 19.3997L16.8521 18.3643L19.4479 20.9602L8.64167 31.7664L11.7333 34.8581L28.3292 18.2768C28.8542 18.4664 29.4229 18.5831 30.0208 18.5831Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6933 23.0321L24.5998 26.1257L33.3442 34.8701L36.4378 31.7766L27.6933 23.0321Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.a4ba956ad0cfdf93a76fc9e97e267f47.svg";
export { ForwardRef as ReactComponent };